import { ICustomSectionTemplateMutation } from 'services/templates/section-template/types';
import { IContractTemplateForm } from 'services/templates/types';
import { separateTemplateTreeItems } from '../templateFormItemsSeparator';

export const sectionTemplateFormToQuery = (
  form: IContractTemplateForm
): ICustomSectionTemplateMutation =>
  separateTemplateTreeItems(form.items[0].children).customSections[0];
